import { F } from '@/utils/intl';
import { Button, Tooltip, Popconfirm } from 'antd';
import React, { useState } from 'react';
import { confirmServiceRequestRequest } from '@/services/api/serviceRequest';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { processSingleServiceRequest } from '@/components/Kanban/ServiceRequests/Calendar/utils';
import { CheckCircleOutlined } from '@ant-design/icons';

const ConfirmServiceRequestAction = ({
                                       serviceRequest,
                                       children,
                                       onSuccess = () => {
                                       },
                                       open,
                                       onOpenChange = () => {},
                                       buttonSize = 'small',
                                       showActionText = false,
                                       ...buttonProps
                                     }) => {

  const [loading, _setLoading] = useState<boolean>(false);
  const handleConfirm = () => {
    _setLoading(true);
    confirmServiceRequestRequest({
      params: {
        serviceRequestId: serviceRequest.id,
      },
    }).then(e => {
      _setLoading(false);
      onSuccess(e);
    });
  };

  if (!processSingleServiceRequest(serviceRequest).isConfirmable) return null;


  return <CheckAccess access={[PERMISSIONS.ServiceRequests.CONFIRM, PERMISSIONS.BUSINESS_PARTNER]}>
    <Popconfirm
      onConfirm={handleConfirm}
      open={open}
      onOpenChange={onOpenChange}
      title={<F id={'pages.serviceRequests.confirmAppointmentConfirm'}
                defaultMessage={'Are you sure to confirm this appointment?'}/>}>
      <Tooltip title={showActionText ? undefined : <F id={'pages.serviceRequests.confirm'} defaultMessage={'Confirm'} />}>
        <Button size={buttonSize} shape={'round'} color={'green'} variant={'filled'}
                onClick={handleConfirm}
                loading={loading}
                icon={<CheckCircleOutlined />} {...buttonProps}>
          {showActionText && <F id={'pages.serviceRequests.confirm'} defaultMessage={'Confirm'}/>}
        </Button>
      </Tooltip>
    </Popconfirm>
  </CheckAccess>;
};

export default ConfirmServiceRequestAction;
